import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	toggleLabel: {
		id: 'personal-settings-preference-fields.common.enable-batching.toggle-label',
		defaultMessage: 'Group notification emails together',
		description: 'Label for toggling email batching ON or OFF',
	},
	infoDialogContent: {
		id: 'personal-settings-preference-fields.common.enable-batching.info-dialog-content',
		defaultMessage:
			'Use this setting to choose how often you want to receive grouped email notifications. By default, we’ll email you three minutes after the last issue update. If more updates are made before three minutes is up, we’ll wait another three minutes. After 10 minutes, we’ll email you anyway.',
		description: 'Content in the dialog box of inline info popup ',
	},
	infoPanelTriggerLabel: {
		id: 'personal-settings-preference-fields.common.enable-batching.info-panel-trigger-label',
		defaultMessage: 'default mode info',
		description: 'Content in the dialog box of inline info popup ',
	},
	infoDialogContentIssueTermRefresh: {
		id: 'personal-settings-preference-fields.common.enable-batching.info-dialog-content-issue-term-refresh',
		defaultMessage:
			'Use this setting to choose how often you want to receive grouped email notifications. By default, we’ll email you three minutes after the last work item update. If more updates are made before three minutes is up, we’ll wait another three minutes. After 10 minutes, we’ll email you anyway.',
		description: 'Content in the dialog box of inline info popup ',
	},
});
